import { render } from "./EstadoTIcketComponent.vue?vue&type=template&id=8fc45cd6"
import script from "./EstadoTIcketComponent.vue?vue&type=script&lang=js"
export * from "./EstadoTIcketComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__